import React, { useEffect, useRef, useState } from "react";

import HttpManager from "../../../../services/HttpManager";
import { serverError } from "../../../../components/modals/payments/register/registerPaymentModal";
import TiraDeMeses from "../../../../components/acuerdos/tiraDeMeses";

/*
	Descuentos › Limpieza (Etapa 5 de cobros). Las matrículas activas que nacieron antes de los acuerdos: WAPP lee lo YA
	PAGADO de cada una y propone la promoción del catálogo por dos caminos, lado a lado: las Reglas (reconocen el patrón de lo
	pagado) y Sonnet (lee pagos, nota de matrícula, solicitud y contrato; `acuerdos:limpieza --ia`). Decisión de Esteban
	(2026-10-20): Caja del plantel aplica UNA POR UNA (ya no existe confirmar en bloque), siempre viendo antes y después mes por
	mes (simulado en el servidor). Nada sube de precio solo; lo pagado no se toca; lo que nadie decide sigue «Por revisar».
	Todo lo valida el servidor.
*/

const http = HttpManager.getInstance();
const num = (n: number | null | undefined) => n === null || n === undefined ? "—" : (Math.round(Number(n) * 100) / 100).toLocaleString("es-MX", { maximumFractionDigits: 2 });
const CONF: Record<string, { label: string; chip: string }> = {
	alta: { label: "Alta", chip: "wdChipAcento" }, media: { label: "Media", chip: "wdChipFilo" }, baja: { label: "Baja", chip: "wdChipOro" }
};
const EFECTO: Record<string, string> = { pagado: "Pagado: no se toca", baja: "Baja", igual: "Igual", subiria: "Subiría: no sube sin tu decisión" };

type Modo = "ia" | "confirmar" | "otra" | "ninguna" | "rechazar";
const ETIQUETA: Record<Modo, string> = { ia: "Aplicar Sugerencia de Sonnet", confirmar: "Aplicar Reglas", otra: "Elegir Otra", ninguna: "Sin Promoción", rechazar: "Rechazar" };

const estadoTira = (m: any) => m.state === "pagado" || m.state === "abono" ? "pagado" : m.pct !== null && m.pct >= 99.5 ? "gratis" : m.pct !== null && m.pct >= 0.5 ? "descuento" : "pendiente";

const Limpieza: React.FC<{ campusId: number; sym: string }> = ({ campusId, sym }) => {
	const [data, setData] = useState<any>(null);
	const [error, setError] = useState<string | null>(null);
	const [f, setF] = useState<{ status: string; confidence: string; pattern: string; flag: boolean; q: string; aiConfidence: string; aiMatch: string }>(
		{ status: "1", confidence: "", pattern: "", flag: false, q: "", aiConfidence: "", aiMatch: "" });
	const [abierto, setAbierto] = useState<any>(null);
	const [dec, setDec] = useState<{ decision: Modo | null; promotionId: number | null; notes: string; subir: boolean }>({ decision: null, promotionId: null, notes: "", subir: false });
	const [busy, setBusy] = useState(false);
	const [cargando, setCargando] = useState<number | null>(null);
	const [aviso, setAviso] = useState<string | null>(null);
	const [page, setPage] = useState<number>(1);
	const arriba = useRef<HTMLDivElement>(null);

	const load = () => {
		http.paymentService.cleanup(campusId, f, page).then((r: any) => { setData(r.data); setError(null); }).catch((e: any) => setError(serverError(e)));
	};
	useEffect(() => {
		const t = setTimeout(load, 250);
		return () => clearTimeout(t);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [campusId, f.status, f.confidence, f.pattern, f.flag, f.q, f.aiConfidence, f.aiMatch, page]);
	useEffect(() => { setAbierto(null); }, [campusId, f.status, f.confidence, f.pattern, f.flag, f.q, f.aiConfidence, f.aiMatch, page]);
	//Otro filtro = empezar en la primera página.
	useEffect(() => { setPage(1); }, [campusId, f.status, f.confidence, f.pattern, f.flag, f.q, f.aiConfidence, f.aiMatch]);

	/* Abre el caso con el modo elegido (o solo a mirar si modo es null). La vista previa se simula con la promoción de ese modo. */
	const abrir = async (row: any, modo: Modo | null) => {
		if (abierto && abierto.id === row.id && dec.decision === modo) { setAbierto(null); return; }
		const promotionId = modo === "ia" ? row.ai?.promotionId : modo === "confirmar" ? row.promotionId : null;
		try {
			setCargando(row.id);
			setError(null);
			const r = await http.paymentService.cleanupItem(campusId, row.id, promotionId || null);
			setAbierto(r.data);
			setDec({ decision: modo, promotionId: null, notes: "", subir: false });
		} catch (e) {
			setError(serverError(e));
		} finally {
			setCargando(null);
		}
	};
	/* En «Elegir Otra», al escoger una promoción se pide su vista previa. */
	const previa = async (row: any, promotionId: number | null) => {
		setDec((d) => ({ ...d, promotionId, subir: false }));
		if (!promotionId) return;
		try {
			setCargando(row.id);
			const r = await http.paymentService.cleanupItem(campusId, row.id, promotionId);
			setAbierto(r.data);
		} catch (e) {
			setError(serverError(e));
		} finally {
			setCargando(null);
		}
	};

	const decidir = async () => {
		if (!abierto || !dec.decision) return;
		const pv = abierto.preview;
		const conPromo = dec.decision === "ia" || dec.decision === "confirmar" || dec.decision === "otra";
		const txt = dec.decision === "ninguna" ? "Queda sin acuerdo; nada cambia de precio."
			: dec.decision === "rechazar" ? "Se rechaza la propuesta; Caja sigue poniendo el descuento a mano."
			: "Se crea el acuerdo" + (pv ? ": " + pv.down + " mes(es) bajan" + (pv.up ? (dec.subir ? " y " + pv.up + " SUBEN (queda en Auditoría)" : "; " + pv.up + " que subirían se quedan como están") : "") : "") + ". Lo pagado no se toca.";
		if (!window.confirm(abierto.name + ": " + txt)) return;
		try {
			setBusy(true);
			const r = await http.paymentService.cleanupDecide(campusId, abierto.id, { decision: dec.decision, promotionId: dec.decision === "otra" ? dec.promotionId : null,
				notes: dec.decision === "ia" ? "" : dec.notes.trim(), permitirSubir: conPromo ? dec.subir : false });
			setAviso(abierto.name + ": " + r.data.text);
			setAbierto(null);
			setError(null);
			load();
		} catch (e) {
			setError(serverError(e));
		} finally {
			setBusy(false);
		}
	};
	const releer = async () => {
		try { setBusy(true); await http.paymentService.cleanupRefresh(campusId); load(); }
		catch (e) { setError(serverError(e)); }
		finally { setBusy(false); }
	};

	if (!data) return error ? <div className="wdAviso">{error}</div> : <div className="loader" />;
	const c = data.counts;
	const reglas = (r: any) => r.promoName ? r.promoName : r.proposalNone ? "Sin Promoción" : "Sin Propuesta";

	const bloqueReglas = (r: any) => (
		<div className="wdSug">
			<div className="wdSugTit">Sugerencia de las Reglas</div>
			<div className="wdSugPromo">{reglas(r)}<span className={"wdChip " + (CONF[r.confidence]?.chip || "wdChipFilo")}>{CONF[r.confidence]?.label || r.confidence}</span></div>
			<div className="wdTenue wdSugRazon" title={r.summary}>{r.patternName}</div>
			{r.noteFlag ? <div className="wdOro wdSugRazon">Nota de Ventas por revisar</div> : null}
		</div>
	);
	const bloqueSonnet = (r: any) => {
		const ai = r.ai;
		return (
			<div className="wdSug">
				<div className="wdSugTit">Sugerencia de Sonnet</div>
				{ai ? (
					<>
						<div className="wdSugPromo">{ai.promoName || "Sin Promoción"}
							<span className={"wdChip " + (CONF[ai.confidence]?.chip || "wdChipFilo")}>{CONF[ai.confidence]?.label || ai.confidence}</span>
							{ai.matchesRules ? <span className="wdChip wdChipFilo">Coincide</span> : null}
						</div>
						{ai.reason ? <div className="wdSugRazon">{ai.reason}</div> : null}
						{ai.flags && ai.flags.length ? <ul className="wdBanderas">{ai.flags.map((x: string, i: number) => <li key={"b" + i}>{x}</li>)}</ul> : null}
					</>
				) : r.aiError ? <div className="wdOro wdSugRazon">{r.aiError}</div> : <div className="wdTenue">Sin Analizar</div>}
			</div>
		);
	};

	const detalle = () => {
		const a = abierto;
		const pv = a.preview;
		const m = dec.decision;
		const opciones = (a.options || []);
		const verPrevia = pv && m !== "ninguna" && m !== "rechazar" && !(m === "otra" && !dec.promotionId);
		const puede = a.statusId === 1 && data.canDecide;
		const pideNota = m === "rechazar" || m === "otra";
		return (
			<div className="wdDetalle" onClick={(e) => e.stopPropagation()}>
				<div style={{ fontSize: 14, margin: "4px 0" }}>{a.summary}</div>
				{a.noteText ? <div className="wdNota" style={{ fontSize: 13 }}><b>Nota de Ventas:</b> {a.noteText}</div> : null}
				{(a.noteClaims || []).map((x: any, i: number) => <div key={"n" + i} className="wdOro" style={{ fontSize: 13 }}>{x.text}</div>)}
				{m === "otra" ? (
					<select className="form-select form-select-sm wdElegir" value={dec.promotionId || ""} onChange={(e) => previa(a, Number(e.target.value) || null)}>
						<option value="">Elige la Promoción</option>
						{opciones.map((o: any) => <option key={o.id} value={o.id} disabled={!!o.problem}>{o.name}{o.problem ? " — " + o.problem : ""}</option>)}
					</select>
				) : null}
				{verPrevia ? (
					<>
						<div style={{ fontSize: 13, marginTop: 6 }}>Con <b>{pv.promoName}</b> ({pv.status.toLowerCase()}){pv.conditions?.text ? ": " + pv.conditions.text : ""}</div>
						<div className="wdTablaCaja">
							<table className="wdTabla">
								<thead><tr><th>Mes</th><th>Lista</th><th>Hoy</th><th>Con el Acuerdo</th><th>Qué Pasa</th></tr></thead>
								<tbody>{pv.months.map((x: any) => (
									<tr key={"pm" + x.tuitionId}>
										<td>{x.title}</td><td>{sym}{num(x.list)}</td><td>{sym}{num(x.before)}</td>
										<td className={x.effect === "subiria" ? "wdOro" : ""}>{sym}{num(x.effect === "subiria" && dec.subir ? x.afterIfRaise : x.after)}</td>
										<td className={x.effect === "subiria" ? "wdOro" : "wdTenue"}>{x.effect === "subiria" ? (dec.subir ? "Sube a " + sym + num(x.afterIfRaise) : EFECTO.subiria) : x.state === "condicionado" && x.effect !== "pagado" ? "Regalo condicionado (no suma al saldo hasta cumplirse)" : EFECTO[x.effect] || x.effect}
											{x.note && x.effect !== "pagado" && x.effect !== "subiria" ? <span className="wdTenue"> {x.note}</span> : null}</td>
									</tr>
								))}</tbody>
							</table>
						</div>
					</>
				) : null}
				{puede && m && pv && pv.up > 0 && verPrevia ? (
					<label className="wdOpcion wdOro"><input type="checkbox" checked={dec.subir} onChange={(e) => setDec({ ...dec, subir: e.target.checked })} />
						Sí, que suban {pv.up === 1 ? "el mes marcado" : "los " + pv.up + " meses marcados"} (lo decido yo; queda en Auditoría)</label>
				) : null}
				{puede && m ? (
					<div className="wdDecidir" style={{ flexDirection: "column", alignItems: "stretch" }}>
						{m !== "ia" ? (
							<input className="form-control form-control-sm" style={{ maxWidth: 520, flex: "0 0 auto" }} value={dec.notes} onChange={(e) => setDec({ ...dec, notes: e.target.value })}
								placeholder={pideNota ? "Por qué (obligatorio, queda en el historial)" : "Nota (opcional)"} />
						) : null}
						{error ? <div className="wdAviso" style={{ margin: 0 }}>{error}</div> : null}
						<div className="wdBotones" style={{ justifyContent: "flex-start" }}>
							<button type="button" className="wdBoton" onClick={() => setAbierto(null)}>Cerrar</button>
							<button type="button" className="wdBoton wdPrimario" onClick={decidir}
								disabled={busy || (pideNota && dec.notes.trim().length < 10) || (m === "otra" && !dec.promotionId)}>
								{busy ? "…" : m === "ia" ? "Aplicar" : m === "confirmar" ? "Aplicar" : m === "otra" ? "Aplicar" : m === "ninguna" ? "Dejar Sin Promoción" : "Rechazar"}</button>
						</div>
					</div>
				) : !puede ? (
					<>
						{a.statusId !== 1 ? (
							<div className="wdTenue" style={{ fontSize: 13, marginTop: 6 }}>{a.status}{a.decidedBy ? " por " + a.decidedBy : ""}{a.decidedAt ? ", " + a.decidedAt.replace("T", " ").slice(0, 16) : ""}
								{a.decisionPromoName ? ". " + a.decisionPromoName : ""}{a.decisionNotes ? ". «" + a.decisionNotes + "»" : ""}</div>
						) : null}
						<div className="wdBotones" style={{ justifyContent: "flex-start" }}><button type="button" className="wdBoton" onClick={() => setAbierto(null)}>Cerrar</button></div>
					</>
				) : (
					<>
						{error ? <div className="wdAviso">{error}</div> : null}
						<div className="wdBotones" style={{ justifyContent: "flex-start" }}><button type="button" className="wdBoton" onClick={() => setAbierto(null)}>Cerrar</button></div>
					</>
				)}
			</div>
		);
	};

	const cuenta = (n: number | undefined) => " (" + (n || 0) + ")";
	const sel = (r: any, m: Modo) => abierto && abierto.id === r.id && dec.decision === m;
	// ‹ 1 / N › arriba y al final de los 100 casos; desde abajo, la página nueva se ve desde su primer caso.
	const irA = (n: number, abajo: boolean) => { setPage(n); if (abajo && arriba.current) arriba.current.scrollIntoView({ block: "start" }); };
	const paginas = (abajo: boolean) => data.lastPage > 1 ? (
		<div ref={abajo ? undefined : arriba} className="wdPaginas" style={{ display: "flex", gap: 8, alignItems: "center", justifyContent: "flex-end", margin: "6px 0" }}>
			<button type="button" className="btn btn-sm btn-outline-secondary" disabled={page <= 1} onClick={() => irA(page - 1, abajo)} aria-label="Página anterior">‹</button>
			<span style={{ fontSize: 13 }}>{data.page} / {data.lastPage}</span>
			<button type="button" className="btn btn-sm btn-outline-secondary" disabled={page >= data.lastPage} onClick={() => irA(page + 1, abajo)} aria-label="Página siguiente">›</button>
		</div>
	) : null;

	return (
		<>
			<div className="wdFiltros">
				<span className="wdChip wdChipOro">{c.porRevisar} Por Revisar</span>
				{c.conNota ? <span className="wdChip wdChipOro">{c.conNota} Con Nota de Ventas por Revisar</span> : null}
			</div>
			<div className="wdFiltros">
				<select className="form-select form-select-sm" style={{ maxWidth: 190 }} value={f.status} onChange={(e) => setF({ ...f, status: e.target.value })} aria-label="Estado">
					<option value="1">Por Revisar</option><option value="2">Confirmadas</option><option value="3">Sin Promoción</option><option value="4">Rechazadas</option><option value="5">Sin Efecto</option><option value="todos">Todas</option>
				</select>
				<select className="form-select form-select-sm" style={{ maxWidth: 210 }} value={f.aiConfidence} onChange={(e) => setF({ ...f, aiConfidence: e.target.value })} aria-label="Confianza de Sonnet">
					<option value="">Confianza de Sonnet</option>
					<option value="alta">{"Sonnet Alta" + cuenta(c.iaAlta)}</option><option value="media">{"Sonnet Media" + cuenta(c.iaMedia)}</option>
					<option value="baja">{"Sonnet Baja" + cuenta(c.iaBaja)}</option><option value="sin">{"Sin Analizar" + cuenta(c.iaSinAnalisis)}</option>
				</select>
				<select className="form-select form-select-sm" style={{ maxWidth: 190 }} value={f.aiMatch} onChange={(e) => setF({ ...f, aiMatch: e.target.value })} aria-label="Coincide o Difiere">
					<option value="">Coincide y Difiere</option>
					<option value="1">{"Coincide" + cuenta(c.iaCoinciden)}</option><option value="0">{"Difiere" + cuenta(c.iaDifieren)}</option>
				</select>
				<select className="form-select form-select-sm" style={{ maxWidth: 210 }} value={f.confidence} onChange={(e) => setF({ ...f, confidence: e.target.value })} aria-label="Confianza de las Reglas">
					<option value="">Confianza de las Reglas</option>
					<option value="alta">{"Reglas Alta" + cuenta(c.alta)}</option><option value="media">{"Reglas Media" + cuenta(c.media)}</option><option value="baja">{"Reglas Baja" + cuenta(c.baja)}</option>
				</select>
				<select className="form-select form-select-sm" style={{ maxWidth: 230 }} value={f.pattern} onChange={(e) => setF({ ...f, pattern: e.target.value })} aria-label="Patrón">
					<option value="">Cualquier Patrón</option>{Object.keys(data.patterns || {}).map((k) => <option key={k} value={k}>{data.patterns[k]}</option>)}
				</select>
				<label className="wdCampo" style={{ display: "flex", gap: 6 }}><input type="checkbox" checked={f.flag} onChange={(e) => setF({ ...f, flag: e.target.checked })} /> Solo Nota de Ventas que no Cuadra</label>
				<input className="form-control form-control-sm" placeholder="Buscar alumno, correlativo o curso" value={f.q} onChange={(e) => setF({ ...f, q: e.target.value })} />
				{data.canDecide ? <button type="button" className="wdLink" disabled={busy} onClick={releer} title={data.inferredAt ? "Leído " + data.inferredAt.replace("T", " ").slice(0, 16) : ""}>Volver a Leer lo Pagado</button> : null}
			</div>
			{error && !abierto ? <div className="wdAviso">{error}</div> : null}
			{aviso ? <div className="wdNota" onClick={() => setAviso(null)}>{aviso}</div> : null}
			{paginas(false)}
			{!data.rows.length ? <div className="wdTenue">Nada con estos filtros.</div> : data.rows.map((r: any) => (
				<div key={"k" + r.id} className={"wdCaso wdLimpia" + (abierto && abierto.id === r.id ? " wdCasoAbierto" : "")}>
					<div className="wdLimpCab" onClick={() => abrir(r, null)}>
						<div style={{ minWidth: 0 }}>
							<b>{r.name}</b>{r.statusId !== 1 ? <span className="wdChip wdChipFilo" style={{ marginLeft: 6 }}>{r.status}</span> : null}
							<div className="wdTenue wdCorta" style={{ fontSize: 12 }}>{r.identityCode} {r.courseName}</div>
						</div>
						<div style={{ minWidth: 0 }}>
							<TiraDeMeses compacta sym={sym} meses={(r.strip || []).map((m: any) => ({ n: m.n, state: estadoTira(m), price: m.price, list: m.list }))} />
						</div>
					</div>
					<div className="wdSugs">{bloqueReglas(r)}{bloqueSonnet(r)}</div>
					{data.canDecide && r.statusId === 1 ? (
						<div className="wdOpciones wdLimpAcc">
							{r.ai && r.ai.promotionId ? <button type="button" className={"wdToggle" + (sel(r, "ia") ? " wdToggleOn" : "")} disabled={cargando === r.id} onClick={() => abrir(r, "ia")}>{ETIQUETA.ia}</button> : null}
							{r.promotionId ? <button type="button" className={"wdToggle" + (sel(r, "confirmar") ? " wdToggleOn" : "")} disabled={cargando === r.id} onClick={() => abrir(r, "confirmar")}>{ETIQUETA.confirmar}</button> : null}
							<button type="button" className={"wdToggle" + (sel(r, "otra") ? " wdToggleOn" : "")} disabled={cargando === r.id} onClick={() => abrir(r, "otra")}>{ETIQUETA.otra}</button>
							<button type="button" className={"wdToggle" + (sel(r, "ninguna") ? " wdToggleOn" : "")} disabled={cargando === r.id} onClick={() => abrir(r, "ninguna")}>{ETIQUETA.ninguna}</button>
							<button type="button" className={"wdToggle" + (sel(r, "rechazar") ? " wdToggleOn" : "")} disabled={cargando === r.id} onClick={() => abrir(r, "rechazar")}>{ETIQUETA.rechazar}</button>
						</div>
					) : null}
					{abierto && abierto.id === r.id ? detalle() : null}
				</div>
			))}
			{data.rows.length > 20 ? paginas(true) : null}
		</>
	);
};

export default Limpieza;
